export default __webpack_public_path__ + "static/media/mobilebanner4.0d6df643.png";